/** A box that can wait on another box's answer. */
export interface VisibleField {
  id: string
  show_when?: { field_id: string; op: string; value?: string }
}

/**
 * Whether a box should be shown given the current answers.
 *
 * Matches FieldIsVisible in the store: a missing controller, a cycle, or a
 * failed condition hides the box. A checkbox counts as checked for "true"
 * while the signer is filling it in and for "X" once it has been stamped.
 */
export function fieldIsVisible(
  fields: VisibleField[],
  values: Record<string, string>,
  id: string,
  stack: Record<string, boolean> = {},
): boolean {
  const f = fields.find((cand) => cand.id === id)
  if (!f) return false
  const rule = f.show_when
  if (!rule?.field_id) return true
  if (stack[id]) return false
  const next = { ...stack, [id]: true }
  if (!fieldIsVisible(fields, values, rule.field_id, next)) return false
  const answer = (values[rule.field_id] ?? '').trim()
  switch (rule.op) {
    case 'checked':
      return isChecked(answer)
    case 'eq':
      return answer === (rule.value ?? '')
    default:
      return false
  }
}

function isChecked(v: string): boolean {
  switch (v.toLowerCase().trim()) {
    case 'true':
    case 'x':
    case 'yes':
    case '1':
    case 'on':
      return true
    default:
      return false
  }
}
